import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { Typography, Box } from "@mui/material";
import PropTypes from "prop-types";
import OEIPopover from "./OEIPopover";
import { pagination } from './pagination'
import Tooltip from '@mui/material/Tooltip';
import { withStyles } from "@mui/styles";
import { getFirstEmail } from "./OEIUtils";
import { USER, SYSTEM_NAME1, EMPTY, EDIT, END, MIDDLE, BUSINESSlINE_lIST, EVENT_TYPE_LIST, SEARCH_EXCLUDED_COLUMNS, SYSTEM_NAME4, } from './Constants'

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
const TextOnlyTooltip = withStyles({
  tooltip: {
    color: "#1A1A1A",
    backgroundColor: "#e6e6e6",
    fontSize: '12px'
  }
})(Tooltip);

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#f6f6f6",
    fontSize: 11,
    fontWeight: "500",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 15,
    fontWeight: 500,
  },
}));
export default function OEITable(props) {
  const scroller = React.useRef(null);
  const [animate, setAnimate] = React.useState(false);
  const topHeaderHeight = 192;
  const [hoverId, setHoverId] = React.useState(null);
  const currentPosts = props.rowData;
  const [popoverName, setPopoverName] = React.useState(EMPTY);
  const [editData, setEditData] = React.useState([])
  const [clickedMore, onClickedMore] = React.useState(false);
  const [showEdit, setShowEdit] = React.useState(0);
  const [pageIndex, setPageIndex] = React.useState(1);
  const [pageValue] = React.useState(100);
  const [middlePopoverName, setMiddlePopoverName] = React.useState(EMPTY);
  const [checkedList, setCheckedList] = React.useState();
  const [type, setType] = React.useState('edit');
  const [searchQuery, setSearchQuery] = React.useState("");
  const [searchFocused, setSearchFocused] = React.useState(false);
  let searchResult = null;

  const getFilteredData = () => {
    let filtered = currentPosts;
    if (searchQuery && searchQuery.length > 1) {
      filtered = currentPosts.filter((row) => {
        for (const column of props.columns) {
          const value = row[column.id];
          if (value && !SEARCH_EXCLUDED_COLUMNS.includes(column.id) && value.toString().toLowerCase().includes(searchQuery.toLowerCase())) {
            return true;
          }
        }
        return false;
      });
    }
    return filtered.sort((a, b) => {
      const nameA = (a[props.filterField] || '').toString().toLowerCase();
      const nameB = (b[props.filterField] || '').toString().toLowerCase();
      return nameB.localeCompare(nameA);
    });
  };

  const filteredData = getFilteredData();
  const filteredDataLength = filteredData.length;
  let totalItems = filteredDataLength;
  let pageCount = Math.ceil(filteredDataLength / pageValue);
  let startIndex = (pageIndex - 1) * pageValue + 1;
  let lastIndex = (Math.ceil(filteredDataLength / pageValue) === pageIndex ? filteredDataLength : pageIndex * pageValue);

  const handlePagination = (dataLength) => {
    totalItems = dataLength;
    pageCount = Math.ceil(dataLength / pageValue);
    startIndex = (pageIndex - 1) * pageValue + 1;
    lastIndex = (Math.ceil(dataLength / pageValue) === pageIndex ? dataLength : pageIndex * pageValue);
  }
  const showEditAndManage = (row) => {
    setHoverId(row.id);
  };
  const hideEditAndManage = (id) => {
    setHoverId(null);
  };
  const manageClicked = (row, name) => {
    if (name === 'Manage') {
      if (props.newAction === "OEC Account Link") {
        edit(row, name);
      }
      sessionStorage.setItem("systemName", row.clientName)
      props.handleManageAcct(row.integrationAcctId);
    } else if (name === EDIT && row.systemName !== SYSTEM_NAME4) {
      edit(row, name)
    }
  }
  const setPopoverName1 = (e) => {
    props.setClosePopover(false);
    props.setErrors({ error1: EMPTY, error2: EMPTY, error3: EMPTY })
    setPopoverName(`New ${props.newAction == 'Mapping' ? 'Salesforce Account Mapping' : props.newAction}`);
  }
  const getPassportData = (data) => {
    var list = [];
    try {
      var jsonData = JSON.parse(data);
      jsonData.map(item => {
        var obj = { PassportTemplateMappingName: item.passportTemplateMappingName, checkedList: item.eventTypes, fileName: item.fileName, pptConfiguration: item.configuration }
        list.push(obj)
      })
    } catch (err) { }
    return list;
  }
  const edit = (row, type) => {
    if(row.systemName !== SYSTEM_NAME4){
      setType(type === "Manage" ? 'manage' : 'Edit')
      setMiddlePopoverName(EMPTY)
      if (props.newAction === 'OEC Account Link' || props.newAction === 'Account' || props.newAction === 'System Mapping' || props.newAction === "Notification" || props.newAction === "Mapping" || props.newAction === "User") {
        onClickedMore(false)
        setPopoverName(`Edit ${props.newAction == 'Mapping' ? 'Salesforce Account Mapping' : props.newAction}`);
        props.setErrors([])
        props.setClosePopover(false)
        setEditData({ ...row, allEmailAddresses: row.allEmailAddresses === undefined ? EMPTY : row.allEmailAddresses })
        setShowEdit(row.id)
        props.setNewData({ ...row, allEmailAddresses: row.allEmailAddresses === undefined ? EMPTY : row.allEmailAddresses })
      }
      if(props.newAction === 'OEC Account Link'){
        props.setNewData({ ...row, newCentralData:  [{knovioCreationAccountId:row.knovioAccountId}], salesforceAccountNumber: row.subAccount, name: row.salesforceAccountName, salesforceAccountName: row.salesforceAccountName, removedData: [], passportData: getPassportData(row.passportConfiguration), centralData: [{knovioCreationAccountId:row.knovioAccountId}], oeCentralAccountName: EMPTY, oeCentralAccountNumber: EMPTY, email: EMPTY, firstName: EMPTY, organization: EMPTY, contactEmail: EMPTY, lastName: EMPTY, clientId: EMPTY, clientName: EMPTY, description: EMPTY, emails: EMPTY, selectedValue: 'Event created', allEmails: EMPTY, checkedList: [] })
      }
      if (props.newAction === 'System Mapping') {
        props.setNewData({ ...row, newCentralData: [], salesforceAccountNumber: row.subAccount, name: row.salesforceAccountName, salesforceAccountName: row.salesforceAccountName, removedData: [], passportData: getPassportData(row.passportConfiguration), centralData: [], oeCentralAccountName: EMPTY, oeCentralAccountNumber: EMPTY, email: EMPTY, firstName: EMPTY, organization: EMPTY, contactEmail: EMPTY, lastName: EMPTY, clientId: EMPTY, clientName: EMPTY, description: EMPTY, emails: EMPTY, selectedValue: 'Event created', allEmails: EMPTY, checkedList: [] })
      }
      if (props.newAction === 'Mapping') {
        let list = []
        props.getSalesforceDetails(row).then(response => {
          response.map(item => {
            const found = list.some(el => el.oeCentralAccountNumber === item.systemIntgId);
            const name = item.subAccountName;

            if (!found) list.push({ oeCentralAccountName: name.substr(name.indexOf('/') + 1, name.length), oeCentralAccountNumber: item.systemIntgId, systemIdInfo: [item.systemIdInfo], checkedList: [item.businessLine] });
            else {
              list.forEach(e2 => {
                if (e2.oeCentralAccountNumber === item.systemIntgId) {
                  e2.checkedList = [...e2.checkedList, item.businessLine]
                  e2.systemIdInfo = [...e2.systemIdInfo, item.systemIdInfo]
                }
              })
            }

          })
          setEditData({ ...row, list, integrationAcctId: response[0].integrationAcctId, salesforceAccountNumber: row.subAccount, salesforceAccountName: row.salesforceAccountName, clientUserId: response[0].clientUserId })
          props.setNewData({ ...row, newCentralData: [], salesforceAccountNumber: row.subAccount, name: row.salesforceAccountName, salesforceAccountName: row.salesforceAccountName, removedData: [], passportData: list, centralData: list, oeCentralAccountName: EMPTY, oeCentralAccountNumber: EMPTY, email: EMPTY, firstName: EMPTY, organization: EMPTY, contactEmail: EMPTY, lastName: EMPTY, systemName: SYSTEM_NAME1, clientId: EMPTY, clientName: EMPTY, description: EMPTY, emails: EMPTY, selectedValue: 'Event created', allEmails: EMPTY, checkedList: [] })
        })
      }
    }
  }
  const onClickSave = () => {
    var errorList = validateData(props, 'new');
    if (errorList.length < 1) {
      setMiddlePopoverName('')
      let obj = { knovioCreationAccountId: props.newData.knovioCreationAccountId, fileName: props.newData.fileName, pptConfiguration: props.newData.pptConfiguration, PassportTemplateMappingName: props.newData.PassportTemplateMappingName, oeCentralAccountNumber: props.newData.oeCentralAccountNumber, oeCentralAccountName: props.newData.oeCentralAccountName, checkedList: props.newData.checkedList }
      props.setNewData({ ...props.newData, newCentralData: [...props.newData.newCentralData, obj], passportData: [...props.newData.passportData, obj], centralData: [...props.newData.centralData, obj] });
      props.setErrors([]);
    }
    else {
      props.setErrors(errorList);
    }
  }
  const openNewPopover = () => {
    setPopoverName1(props.newAction);
    setMiddlePopoverName(EMPTY)
    props.setGenerate(true);
    setCheckedList(props.newAction === 'System Mapping' ? EVENT_TYPE_LIST : BUSINESSlINE_lIST)
    props.setNewData({ accountName: EMPTY, accountNumber: EMPTY, pptConfiguration: EMPTY, PassportTemplateMappingName: EMPTY, salesforceAccountNumber: EMPTY, removedData: [], salesforceAccountName: EMPTY, newCentralData: [], passportData: [], centralData: [], oeCentralAccountName: EMPTY, oeCentralAccountNumber: EMPTY, email: EMPTY, firstName: EMPTY, organization: EMPTY, contactEmail: EMPTY, lastName: EMPTY, systemName: SYSTEM_NAME1, clientId: EMPTY, clientName: EMPTY, description: EMPTY, emails: EMPTY, selectedValue: 'Event created', allEmails: EMPTY, checkedList: [] })
    // setCheckedList([{ key:BUSINESSLINE1, value: UNCHECKED }, { key: BUSINESSLINE2, value: UNCHECKED }, { key: BUSINESSLINE3, value: UNCHECKED }, { key: BUSINESSLINE4, value: UNCHECKED }, { key: BUSINESSLINE5, value: UNCHECKED }, { key: BUSINESSLINE6, value: UNCHECKED }, { key: BUSINESSLINE7, value: UNCHECKED }, { key: BUSINESSLINE8, value: UNCHECKED }, { key: BUSINESSLINE9, value: UNCHECKED }, { key: BUSINESSLINE10, value: UNCHECKED }])
    props.setGenerate(true);
    setEditData([])
  }
  const getPagnatedData = () => {
    const calculatedStartIndex = (pageIndex - 1) * pageValue + 1;
    const calculatedLastIndex = (Math.ceil(filteredDataLength / pageValue) === pageIndex ? filteredDataLength : pageIndex * pageValue);
    return filteredData.slice(calculatedStartIndex - 1, calculatedLastIndex);
  }
  const SystemMappingTabTab = () => {
    props.history.push(`/accounts/accountmapping/${props.match.params.id}`);
  }
  const NotificationTab = () => {
    props.history.push(`/accounts/notification/${props.match.params.id}`);
  }
  const showEmails = (emails) => {
    return emails.replace(/,/g, "\n");

  }
  const getFirstTwoOf = (data) => {
    return data.indexOf(',', data.indexOf(',') + 1) > 1 ? data.substr(data, data.indexOf(',', data.indexOf(',') + 1)) : data;
  }
  const editOnClick = () => {
    if("OEC Account Link"===props.newAction){
      props.setNewData({ ...props.newData, centralData:  [{knovioCreationAccountId:props.newData.knovioCreationAccountId }]});
      setMiddlePopoverName(EMPTY)
    }
    else{
    var errorList = []
    errorList = validateData(props, 'edit');
    if (props.newData.editItem.PassportTemplateMappingName !== props.newData.PassportTemplateMappingName)
      if (checkduplicatename(props.newData.PassportTemplateMappingName, props.newData.passportData)) {
        errorList = { ...errorList, error3: 'Passport Template MappingName is already exists' }
      }
    if (errorList.length < 1) {
      props.removeMainItem(props.newData.editItem);
      setMiddlePopoverName(EMPTY)
      let obj = { fileName: props.newData.fileName, pptConfiguration: props.newData.pptConfiguration, PassportTemplateMappingName: props.newData.PassportTemplateMappingName, oeCentralAccountNumber: props.newData.oeCentralAccountNumber, oeCentralAccountName: props.newData.oeCentralAccountName, checkedList: props.newData.checkedList }
      props.setNewData({ ...props.newData, newCentralData: [...props.newData.newCentralData, obj], passportData: [...props.newData.passportData, obj], centralData: [...props.newData.centralData, obj] });
      props.setErrors([]);
    }
    else {
      props.setErrors(errorList);
    }
  }
    // props.setNewData()
  }
  const checkduplicatename = (name, list) => {
    var val = false;
    list.map(item => { if (item.PassportTemplateMappingName === name) { val = true } })
    return val;
  }
  function validateData(props, type) {
    var errorList = [];
    if (props.newAction === 'OEC Account Link') {
      if (props.newData.centralData.length > 0) {
        errorList = { ...errorList, error4: 'Account mapping with given system is already exists.' };
      }
      if (props.newData.knovioCreationAccountId === EMPTY) {
        errorList = { ...errorList, error5: 'Knovio Creation AccountId is required' };
      }
      if (! /^\d+$/.test(props.newData.knovioCreationAccountId)) {
        errorList = ({ ...errorList, error5: 'Knovio Account Numbers are made up of numbers only' })

      }
    }
    else if (props.newAction === 'System Mapping') {
      if (props.newData.PassportTemplateMappingName === EMPTY) {
        errorList = { ...errorList, error3: 'Passport Template MappingName is required' };
      }
      if (props.newData.pptConfiguration === EMPTY) {
        errorList = { ...errorList, error8: 'Passport Template is required' };
      }
      if (props.newData.checkedList.length < 1) {
        errorList = { ...errorList, error5: 'At least one Event Type is required' };
      }
      if (type === 'new') {
        if (checkduplicatename(props.newData.PassportTemplateMappingName, props.newData.passportData)) {
          errorList = { ...errorList, error3: 'Passport Template MappingName is already exists' };
        }
      }
    } else {
      if (props.newData.oeCentralAccountNumber === EMPTY) {
        errorList = { ...errorList, error3: 'Central Account number is required' };
      } else if (props.newData.oeCentralAccountNumber.length > 255) {
        errorList = { ...errorList, error3: 'Central Account number length should be less than 255 characters' };
      }
      if (props.newData.oeCentralAccountName === EMPTY) {
        errorList = { ...errorList, error4: 'Central account name is required' };
      }
      else if (props.newData.oeCentralAccountName.length > 255) {
        errorList = { ...errorList, error4: 'Central Account name length should be less than 255 characters' };
      }
      if (props.newData.checkedList.length < 1) {
        errorList = { ...errorList, error5: 'At least one business mapping is required' };
      }
    }
    return errorList;
  }

  function updateScrollPosition() {
    if (scroller && scroller.current) {
        const pageYOffset = Math.abs(scroller.current.getBoundingClientRect().y);
        const offsetHeight = scroller.current.offsetHeight;
        const scrollHeight = scroller.current.scrollHeight;
        const viewWindowHeight = offsetHeight + (2 * topHeaderHeight);
        if (scrollHeight > viewWindowHeight && pageYOffset > topHeaderHeight) {
            setAnimate(true);
        } else {
            setAnimate(false);
        }
    }
 }
 React.useEffect(() => {
    window.addEventListener('scroll', updateScrollPosition, false);
    return () => window.removeEventListener('scroll', updateScrollPosition, false);
  });
  React.useEffect(() => {
    setPageIndex(1);
  }, [searchQuery]);

  return (
    <div className='oe-connect' ref={scroller}>
      <div className={`oe-connect__root-page ${animate && 'oe-connect__root-page--animate'}`}>
        <div className="page-container">
          <div className={props.headerStyle}>
            <section className="top-page-title horizontal-row horizontal-row--with-bottom-margin">
              <h1 style={{ paddingTop: '20px', paddingBottom: '10px' }} className="text-ellipsis">{props.tableHeadings} </h1>
              {props.newAction === 'Account' || props.newAction === USER || props.newAction === 'Mapping' || props.newAction === 'OEC Account Link' ?
                <div className="horizontal-row__align-to-row-end">
                  <div style={{ paddingTop: '15px', paddingBottom: '0px' }} className="buttons-block">
                    <button onClick={e => openNewPopover()} type="button" className="default-button default-button--fat events-list__button-new">
                      <span>{`+ New ${props.newAction}`}</span>
                    </button>
                  </div>
                </div> : EMPTY
              }
            </section>
            {props.newAction === 'Account' || props.newAction === USER || props.newAction === 'Mapping' || props.newAction === 'OEC Account Link' ? EMPTY :
              <section style={{ position: 'sticky', top: 0 }}
                className="horizontal-row horizontal-row--with-bottom-margin event-tabs-tracker">
                <div className="navigation-row">
                  <a onClick={SystemMappingTabTab} className={`${props.tabClicked === 'systemmapping' ? "active navigation-row__button navigation-row__button--active" : 'active navigation-row__button navigation-row__button'}`}>System Mapping</a>
                  <a onClick={NotificationTab} className={`${props.tabClicked === 'notification' ? "active navigation-row__button navigation-row__button--active" : 'active navigation-row__button navigation-row__button'}`}>Notifications</a>
                  {/* <a onClick={UsersTab}className={ `${props.tabClicked=='users'?"active navigation-row__button navigation-row__button--active":'active navigation-row__button navigation-row__button'}`}>Users</a>  */}

                </div>
                <div className="horizontal-row__align-to-row-end">
                  <div className="buttons-block">
                    <button onClick={e => openNewPopover()} type="button" className="default-button default-button--fat events-list__button-new">
                      <span>{`+ New ${props.newAction}`}</span>
                    </button>
                  </div>
                </div>
              </section>}
          </div>
          <Table size="small" style={{tableLayout: "fixed", borderCollapse: "separate"}}>
            <TableHead
              className={props.tableHeaderStyle}
            >
              <TableRow >
                {props.columns.map((column) => (
                  !column.disable && <StyledTableCell
                    style={{
                      height: "43px",
                      borderTop: "1px solid #949494",
                      borderBottom: "1px solid #949494",
                      width: column.width,
                      whiteSpace: "unset",
                    }}
                    key={column.id}
                    align={column.align}
                  >
                    {column.label}
                  </StyledTableCell>
                ))}
                {(props.newAction === "Account" || props.newAction === 'Mapping' ) && (
                  <StyledTableCell
                    style={{
                      height: "43px",
                      borderTop: "1px solid #949494",
                      borderBottom: "1px solid #949494",
                      cursor: "text",
                      paddingRight: "8px",
                      position: "relative",
                      width: '10%',
                      textAlign: 'end'
                    }}
                  >
                    <div style={{ position: "relative", display: "inline-block" }}>
                      <input type="text" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} placeholder="Search" className="search-bar"
                        onMouseEnter={(e)=>{e.target.style.outline= '1px solid #949494';}}
                        onMouseLeave={(e)=>{searchFocused ? e.target.style.outline= '1px solid #00787A': e.target.style.outline = 'none';}}
                        onFocus={(e)=>{setSearchFocused(true); e.target.style.outline = '1px solid #00787A';}}
                        onBlur={(e)=>{setSearchFocused(false); e.target.style.outline = 'none';}}
                      />
                      {searchQuery && (
                        <span onClick={() => setSearchQuery("")} style={{ position: "absolute", top: "50%", right: "4px", transform: "translateY(-50%)", cursor: "pointer" }}>
                          <div className="reset-button" style={{ width: "20px", height: "16px", borderRadius: "50%", backgroundColor: "#00787a", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <span style={{ color: "white", fontSize: "10px", fontFamily: "Material-Icons"}}>&#10005;</span>
                          </div>
                        </span>
                      )}
                    </div>
                  </StyledTableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {(searchResult = getPagnatedData()) && searchResult && searchResult?.length > 0 ? (searchResult.map((row) => (
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={row.code}
                  scope="row"
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  style={{
                    height: "50px", whiteSpace: "unset", borderBottom: '1px solid #949494',
                    backgroundColor: (row.id === editData.id) && !props.closePopover ? '#C4F8E4' : EMPTY
                  }}
                >
                  {props.columns.map((column) => {
                    const value = row[column.id];
                    const allEmailAddresses = row['allEmailAddresses']
                    const emails = `${value ? value + (allEmailAddresses ? ',' : EMPTY) : EMPTY}${allEmailAddresses ? (allEmailAddresses) : EMPTY}`
                    return (
                      <>
                        {column.id === "Manage" || (column.id === EDIT && props.newAction === 'Mapping') ? (
                          <TableCell
                            style={{borderBottom: "1px solid #949494", textAlign: "right"}}
                            onDoubleClick={() => edit(row)}
                            onMouseEnter={() => showEditAndManage(row)}
                            onMouseLeave={() => hideEditAndManage(row)}
                          >

                            {hoverId === row.id ? (
                              <button type="button" onClick={() => manageClicked(row, `${(column.id === EDIT && props.newAction === 'Mapping') ? column.id : column.buttonLabel}`)} class="default-button manage-button default-button--slim visible-while-hovered">
                                <span class="">{column.buttonLabel}</span>
                              </button>
                            ) : (
                              ""
                            )}
                          </TableCell>
                        ) : (
                          <TableCell
                            style={{borderBottom: "1px solid #949494"}}
                            key={column.id}
                            align={column.align}
                            onDoubleClick={() => edit(row)}
                            onMouseEnter={() => showEditAndManage(row)}
                            onMouseLeave={() => hideEditAndManage(row)}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                height: "inherit",
                                color: '#1A1A1A'
                              }}
                            >
                              {column.id === 'emailAddresses' ? <TextOnlyTooltip title={<span style={{ whiteSpace: 'pre-line' }}>{showEmails(emails)}</span>}
                                placement="bottom"><div>
                                  <div className="tooltip" style={{ maxWidth: '200px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{getFirstEmail(emails)}</div>
                                  <div className="tooltip" style={{ maxHeight: '200px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', color: '#00787A', paddingLeft: '5px' }}>{emails.includes(',') ? '+ ' : EMPTY}{emails.includes(',') ? emails.split(',').length - 1 : EMPTY}</div>
                                </div>
                              </TextOnlyTooltip>
                                : column.id === 'centalAccountNames' || column.id === 'centalAccountNumbers' ?
                                  <TextOnlyTooltip title={<span style={{ whiteSpace: 'pre-line' }}>{showEmails(emails)}</span>}
                                    placement="bottom"><div>
                                      <div className="tooltip" style={{ maxWidth: '200px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{getFirstTwoOf(value)}</div>
                                      <div className="tooltip" style={{ maxHeight: '200px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', color: '#00787A', paddingLeft: '5px' }}>{value.split(',').length > 2 ? `+${value.split(',').length - 2}` : EMPTY}</div>
                                    </div>
                                  </TextOnlyTooltip>
                                  : <div className="tooltip" style={{ maxWidth: '200px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{value === 'Event Updated' ? 'Event Edited' : value}</div>
                              }
                              <div>
                                {column.edit && (showEdit !== row.id) ? (
                                  hoverId === row.id && row.systemName !== SYSTEM_NAME4 ? (
                                    <button type="button" onClick={() => edit(row)} class="default-button default-button--slim default-button--link visible-while-hovered">
                                      <span class="">Edit</span></button>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </TableCell>
                        )}
                      </>
                    );
                  })}
                </TableRow>
                ))):
                (!props?.message &&
                  <TableRow key="no-content" style={{ height: "50px", whiteSpace: "unset" }}>
                    <TableCell colSpan={props?.columns?.length} style={{ textAlign: 'center', padding: "30px", borderBottom: '1px solid #949494' }} className='empty-list-message'>
                      No content
                    </TableCell>
                  </TableRow>
                )
              }
            </TableBody>
          </Table>
          {(() => {
            handlePagination(filteredDataLength);
            return null;
          })()}
          {(filteredDataLength > 100) ?
            <div>{pagination(pageCount, pageIndex, setPageIndex, totalItems, pageValue, startIndex, lastIndex)}</div>
            : <>
              {props.message.includes('loading') ? <div className='empty-message'>{props.message}</div> :
                props.message && <div className='empty-list-message'>{props.message}</div>}</>}
        </div>
        <OEIPopover removeMainItem={props.removeMainItem} checkedList={checkedList} popoverType={type}
          setCheckedList={setCheckedList} setMiddlePopoverName={setMiddlePopoverName} type={END} setShowEdit={setShowEdit} clickedMore={clickedMore} onClickedMore={onClickedMore} delete={props.delete}
          closePopover={props.closePopover} setClosePopover={props.setClosePopover}
          popoverName={popoverName} checked={props.checked} setChecked={props.setChecked} newData={props.newData}
          generate={props.generate} handleClickGenerate={props.handleClickGenerate} errors={props.errors} setErrors={props.setErrors}
          setGenerate={props.setGenerate} createAccount={props.createAccount}
          setNewData={props.setNewData} onclick={props.onclick} setPopoverName={setPopoverName}
          editData={editData} setEditData={setEditData} edit={() => props.edit(editData, props.newData)} email={props.email} setEmail={props.setEmail} middlePopoverName={middlePopoverName}></OEIPopover>
        {middlePopoverName.length > 0 ? <OEIPopover removeMainItem={props.removeMainItem} checkedList={checkedList} setCheckedList={setCheckedList} middlePopoverName={middlePopoverName} type={MIDDLE} setShowEdit={setShowEdit} clickedMore={clickedMore} onClickedMore={onClickedMore} delete={props.delete}
          closePopover={props.closePopover} setMiddlePopoverName={setMiddlePopoverName} setClosePopover={props.setClosePopover}
          popoverName={popoverName} checked={props.checked} setChecked={props.setChecked} newData={props.newData}
          generate={props.generate} handleClickGenerate={props.handleClickGenerate} errors={props.errors} setErrors={props.setErrors}
          setGenerate={props.setGenerate} createAccount={props.createAccount} popoverType={type}
          setNewData={props.setNewData} onclick={() => onClickSave()} setPopoverName={setMiddlePopoverName}
          editData={editData} setEditData={setEditData} edit={editOnClick} email={props.email} setEmail={props.setEmail}></OEIPopover>
          : EMPTY}  </div>
    </div>
  );
}
